import React, { useEffect } from 'react';
import {
  Button,
  spacing6,
  Typography,
} from '@leaftrade/leaftrade-component-library';
import { BrandPageButtonStyles } from '../../../../../shared/styles/BrandPageButton.styles';
import { EditorialBlockWrapper } from './EditorialBlock.styles';
import {
  brandPageTileClickEvent,
  brandPageTileViewEvent,
} from '../../../../analytics/brand_pages';
import { GradientWrapper } from '../styles/GradientWrapper';

const EditorialBlockTile = ({
  className,
  bodyCopy,
  buttonLabel,
  buttonUrl,
  headline,
  imageUrl,
  subheader,
  position,
  page,
  gradientBackgroundColor,
  textColor,
}) => {
  useEffect(() => {
    brandPageTileViewEvent({
      vendorId: page.vendorId,
      brandId: page.brandId,
      brandPageId: page.id,
      brandPageTilePosition: position,
      brandPageTileMediaUrl: imageUrl,
    });
  });

  const trackAndOpenWindow = () => {
    brandPageTileClickEvent({
      vendorId: page.vendorId,
      brandId: page.brandId,
      brandPageId: page.id,
      brandPageTilePosition: position,
      brandPageTileMediaUrl: imageUrl,
      brandPageTileClickTargetUrl: buttonUrl,
    });

    window.open(buttonUrl, '_blank');
  };

  return (
    <div className={className} style={{ backgroundImage: `url(${imageUrl})` }}>
      <GradientWrapper
        gradientBackgroundColor={gradientBackgroundColor}
        textColor={textColor}
      >
        <EditorialBlockWrapper>
          <div className='brand-page__tile-content'>
            <Typography component='h3' classes={['brand-page__tile-title']}>
              {headline}
            </Typography>
            <Typography component='p' classes={['brand-page__tile-subtitle']}>
              {subheader}
            </Typography>
            <Typography
              component='p'
              classes={['brand-page__tile-description']}
            >
              {bodyCopy}
            </Typography>
            <Button
              size='small'
              bodyStyle={BrandPageButtonStyles}
              onClick={trackAndOpenWindow}
              sx={{ marginTop: spacing6 }}
              classes={['brand-page__tile-button']}
            >
              {buttonLabel}
            </Button>
          </div>
        </EditorialBlockWrapper>
      </GradientWrapper>
    </div>
  );
};

export default EditorialBlockTile;
